import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup, FormControl, Validators} from '@angular/forms';

import {AuthService} from '../../../../services/auth.service';

@Component({
  selector: 'app-forgotpwd',
  templateUrl: 'forgot-pwd.component.html',
  styleUrls: ['../../user.component.scss'],
})

export class forgotPwdComponent implements OnInit {

  public showSuccess: boolean;
  public showErrorMsg = false;
  public showLoader = false;
  forgotPwdForm: FormGroup;

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.forgotPwdForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])
    });
  }

  constructor(private activeModal: NgbActiveModal,
              private authAPIs: AuthService) {
  }

  closeModal() {
    this.activeModal.close();
  }

  forgotPwdFun() {
    this.showLoader = true;
    this.authAPIs.forgotPwd(this.forgotPwdForm.value).subscribe(res => {
      this.showLoader = false;
      if (res.success === true) {
        this.showSuccess = true;
      } else if (res.statusCode === 105 && res.success === false) {
        this.showErrorMsg = true;
      } else {
        // console.log(res.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/forgot-pwd/forgot-pwd.component.ts